import { useFrontendApiConfig } from "../FrontendApiConfigProvider";
import { GqlObj, GqlObjConfig } from "./types";

export function useGraphqlObjConfig(query: GqlObj): GqlObjConfig {
  const contextConfig = useFrontendApiConfig();
  const { config: queryConfig } = query;
  const shouldUseQueryConfig =
    queryConfig && !!queryConfig.endpoint && !!queryConfig.schema;
  return shouldUseQueryConfig
    ? queryConfig
    : {
        endpoint: contextConfig.graphQLEndpoint,
        schema: contextConfig.schema,
      };
}
